var map = {
	"./dashboard/workplace": [
		5044,
		9,
		1313,
		4551,
		1175,
		6118,
		9269,
		1039,
		6784,
		7969
	],
	"./dashboard/workplace/": [
		5044,
		9,
		1313,
		4551,
		1175,
		6118,
		9269,
		1039,
		6784,
		7969
	],
	"./dashboard/workplace/announcement": [
		6119,
		9,
		1313,
		6119
	],
	"./dashboard/workplace/announcement.tsx": [
		6119,
		9,
		1313,
		6119
	],
	"./dashboard/workplace/assets/calendar.svg": [
		1333,
		9,
		1333
	],
	"./dashboard/workplace/assets/comments.svg": [
		3965,
		9,
		3965
	],
	"./dashboard/workplace/assets/content.svg": [
		390,
		9,
		390
	],
	"./dashboard/workplace/assets/increase.svg": [
		3039,
		9,
		3039
	],
	"./dashboard/workplace/carousel": [
		7236,
		9,
		7236
	],
	"./dashboard/workplace/carousel.tsx": [
		7236,
		9,
		7236
	],
	"./dashboard/workplace/content-percentage": [
		5066,
		9,
		4551,
		3951
	],
	"./dashboard/workplace/content-percentage.tsx": [
		5066,
		9,
		4551,
		3951
	],
	"./dashboard/workplace/docs": [
		6779,
		9,
		6779
	],
	"./dashboard/workplace/docs.tsx": [
		6779,
		9,
		6779
	],
	"./dashboard/workplace/index": [
		5044,
		9,
		1313,
		4551,
		1175,
		6118,
		9269,
		1039,
		6784,
		7969
	],
	"./dashboard/workplace/index.tsx": [
		5044,
		9,
		1313,
		4551,
		1175,
		6118,
		9269,
		1039,
		6784,
		7969
	],
	"./dashboard/workplace/locale": [
		5599,
		9,
		5599
	],
	"./dashboard/workplace/locale/": [
		5599,
		9,
		5599
	],
	"./dashboard/workplace/locale/index": [
		5599,
		9,
		5599
	],
	"./dashboard/workplace/locale/index.ts": [
		5599,
		9,
		5599
	],
	"./dashboard/workplace/mock": [
		6637,
		9,
		9269,
		6637
	],
	"./dashboard/workplace/mock/": [
		6637,
		9,
		9269,
		6637
	],
	"./dashboard/workplace/mock/index": [
		6637,
		9,
		9269,
		6637
	],
	"./dashboard/workplace/mock/index.ts": [
		6637,
		9,
		9269,
		6637
	],
	"./dashboard/workplace/overview": [
		6784,
		9,
		4551,
		6784,
		6411
	],
	"./dashboard/workplace/overview.tsx": [
		6784,
		9,
		4551,
		6784,
		6411
	],
	"./dashboard/workplace/popular-contents": [
		9772,
		9,
		1313,
		1175,
		6118,
		9772
	],
	"./dashboard/workplace/popular-contents.tsx": [
		9772,
		9,
		1313,
		1175,
		6118,
		9772
	],
	"./dashboard/workplace/shortcuts": [
		8985,
		9,
		8985
	],
	"./dashboard/workplace/shortcuts.tsx": [
		8985,
		9,
		8985
	],
	"./dashboard/workplace/style/announcement.module.less": [
		4145,
		9,
		4145
	],
	"./dashboard/workplace/style/docs.module.less": [
		5433,
		9,
		5433
	],
	"./dashboard/workplace/style/index.module.less": [
		4130,
		9,
		4130
	],
	"./dashboard/workplace/style/overview.module.less": [
		7457,
		9,
		7457
	],
	"./dashboard/workplace/style/popular-contents.module.less": [
		2022,
		9,
		2022
	],
	"./dashboard/workplace/style/shortcuts.module.less": [
		9175,
		9,
		9175
	],
	"./example": [
		427,
		9,
		427
	],
	"./example/": [
		427,
		9,
		427
	],
	"./example/index": [
		427,
		9,
		427
	],
	"./example/index.tsx": [
		427,
		9,
		427
	],
	"./exception/403": [
		9076,
		9,
		2691,
		2210
	],
	"./exception/403/": [
		9076,
		9,
		2691,
		2210
	],
	"./exception/403/index": [
		9076,
		9,
		2691,
		2210
	],
	"./exception/403/index.tsx": [
		9076,
		9,
		2691,
		2210
	],
	"./exception/403/locale": [
		6463,
		9,
		6463
	],
	"./exception/403/locale/": [
		6463,
		9,
		6463
	],
	"./exception/403/locale/index": [
		6463,
		9,
		6463
	],
	"./exception/403/locale/index.ts": [
		6463,
		9,
		6463
	],
	"./exception/403/style/index.module.less": [
		5274,
		9,
		5274
	],
	"./live": [
		4947,
		9,
		1313,
		1175,
		4947
	],
	"./live/": [
		4947,
		9,
		1313,
		1175,
		4947
	],
	"./live/icons/bdo_online.png": [
		4330,
		1,
		4330
	],
	"./live/icons/bdo_online.svg": [
		8852,
		9,
		8852
	],
	"./live/icons/boost-logo.svg": [
		7714,
		9,
		7714
	],
	"./live/icons/bpi_online.svg": [
		4238,
		9,
		4238
	],
	"./live/icons/chinabank_online.png": [
		9980,
		1,
		9980
	],
	"./live/icons/chinabank_online.svg": [
		6874,
		9,
		6874
	],
	"./live/icons/cimb_online.png": [
		5014,
		1,
		5014
	],
	"./live/icons/cimb_online.svg": [
		126,
		9,
		126
	],
	"./live/icons/gcash_online.png": [
		8271,
		1,
		8271
	],
	"./live/icons/gcash_online.svg": [
		1590,
		9,
		9209
	],
	"./live/icons/grab.png": [
		1457,
		1,
		1457
	],
	"./live/icons/grab.svg": [
		5155,
		9,
		5155
	],
	"./live/icons/lto.png": [
		7864,
		1,
		7864
	],
	"./live/icons/lto.svg": [
		3628,
		9,
		3628
	],
	"./live/icons/maya_online.png": [
		7865,
		1,
		7865
	],
	"./live/icons/maya_online.svg": [
		1637,
		9,
		1637
	],
	"./live/icons/rcbc_online.png": [
		1789,
		1,
		1789
	],
	"./live/icons/rcbc_online.svg": [
		1425,
		9,
		1425
	],
	"./live/icons/unionbank_online.svg": [
		3034,
		9,
		3034
	],
	"./live/index": [
		4947,
		9,
		1313,
		1175,
		4947
	],
	"./live/index.tsx": [
		4947,
		9,
		1313,
		1175,
		4947
	],
	"./live/style/index.module.less": [
		2771,
		9,
		2771
	],
	"./login": [
		6214,
		9
	],
	"./login/": [
		6214,
		9
	],
	"./login/banner": [
		5826,
		9,
		5826
	],
	"./login/banner.tsx": [
		5826,
		9,
		5826
	],
	"./login/form": [
		4917,
		9
	],
	"./login/form.tsx": [
		4917,
		9
	],
	"./login/index": [
		6214,
		9
	],
	"./login/index.tsx": [
		6214,
		9
	],
	"./login/locale": [
		9773,
		9
	],
	"./login/locale/": [
		9773,
		9
	],
	"./login/locale/index": [
		9773,
		9
	],
	"./login/locale/index.ts": [
		9773,
		9
	],
	"./login/style/index.module.less": [
		8464,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;